import { AnimatePresence, motion } from "motion/react";
import { formatShortTime, getCatalog } from "../i18n";
import { panelSpring, uiSpring } from "../lib/motion";
import { usePresentedEvents } from "../presentation/hooks";
import { useNexusStore } from "../store/nexusStore";

export function TimelineRail() {
  const events = usePresentedEvents();
  const activateNode = useNexusStore((state) => state.activateNode);
  const locale = useNexusStore((state) => state.locale);
  const ui = getCatalog(locale).ui;

  return (
    <motion.footer
      className="timeline"
      initial={{ opacity: 0, y: 14, scale: 0.995, filter: "blur(4px)" }}
      animate={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
      transition={panelSpring}
    >
      <div className="timeline__title">
        <span className="signal-dot" aria-hidden="true" />
        <div>
          <b>{ui.activity}</b>
          <small>{ui.liveEventFabric}</small>
        </div>
      </div>
      <div className="timeline__rail" role="region" aria-label={ui.activity}>
        <AnimatePresence initial={false} mode="popLayout">
          {events.map((event) => (
            <motion.button
              layout="position"
              initial={{ opacity: 0, x: 14 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -8 }}
              transition={uiSpring}
              key={event.id}
              className={`timeline-event timeline-event--${event.severity}`}
              onClick={() => activateNode(event.sourceNodeId)}
            >
              <time dateTime={event.timestamp}>{formatShortTime(event.timestamp, locale)}</time>
              <span>{event.title}</span>
            </motion.button>
          ))}
        </AnimatePresence>
      </div>
    </motion.footer>
  );
}
